/**
 * INSTITUTIONAL DEPTH V1 (LOT 1) — Breadcrumbs : fil d'ariane institutionnel.
 * Nav visible (uppercase 11px, séparateur filet) + helper `breadcrumbJsonLd`
 * pour déclarer le MÊME chemin en BreadcrumbList via SEOHead (source unique).
 * `items: [{ label, to? }]` — le dernier élément est la page courante (pas de lien).
 */
import React from 'react';
import { Link } from 'react-router-dom';

const SITE = 'https://www.wealth-management-assets.com';

/** BreadcrumbList schema.org construit des MÊMES items rendus. */
export const breadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.label,
    ...(it.to ? { item: `${SITE}${it.to}` } : {}),
  })),
});

export const Breadcrumbs = ({ items = [], tone = 'light', className = '', testid, ariaLabel = "Fil d'ariane" }) => {
  const dark = tone === 'dark';
  return (
    <nav aria-label={ariaLabel} className={className} data-testid={testid}>
      <ol className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${it.label}-${i}`} className="flex items-center gap-3">
              {i > 0 && (
                <span className={`block w-3 h-px ${dark ? 'bg-ivory/30' : 'bg-graphite/40'}`} aria-hidden="true" />
              )}
              {last || !it.to ? (
                <span
                  aria-current={last ? 'page' : undefined}
                  className={`text-[11px] tracking-[0.14em] uppercase font-medium ${dark ? 'text-ivory/85' : 'text-charcoal'}`}
                >
                  {it.label}
                </span>
              ) : (
                <Link
                  to={it.to}
                  className={`text-[11px] tracking-[0.14em] uppercase font-medium transition-colors duration-200 ${dark ? 'text-ivory/55 hover:text-gold' : 'text-graphite/70 hover:text-gold-dark'}`}
                >
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
